export default __webpack_public_path__ + "static/media/02AW3FEB66.3a11ac5f.jpg";